import { MouseEvent, useCallback, useMemo } from 'react';
import { Chain } from '@ankr.com/chains-list';

import { IProjectWithBlockchains } from 'domains/projects/types';
import { filterChainByPaths } from 'modules/chains/utils/filterChainByPaths';
import { useTokenManagerConfigSelector } from 'domains/jwtToken/hooks/useTokenManagerConfigSelector';

export interface IUsePrivateChainCardActionsProps {
  chain: Chain;
  chainProjects?: IProjectWithBlockchains[];
  handleClose: () => void;
  onOpenAddToProjectsDialog: () => void;
}

// TODO: https://ankrnetwork.atlassian.net/browse/MRPC-7331
export const HIDE_MM_BUTTON = true;

export const usePrivateChainCardActions = ({
  chain,
  chainProjects,
  handleClose,
  onOpenAddToProjectsDialog,
}: IUsePrivateChainCardActionsProps) => {
  const handleOpenAddToProjectsDialog = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      e.preventDefault();
      onOpenAddToProjectsDialog();
      handleClose();
    },
    [handleClose, onOpenAddToProjectsDialog],
  );

  // const isAddToMetamaskButtonVisible = hasEvmSubchains(chain);
  const isAddToMetamaskButtonVisible = !HIDE_MM_BUTTON;

  // TODO: remove it (tech debt)
  const { tokenIndex: selectedProjectIndex } = useTokenManagerConfigSelector();

  const selectedProject = useMemo(
    () =>
      chainProjects?.find(project => project.index === selectedProjectIndex),
    [chainProjects, selectedProjectIndex],
  );

  const chainPaths = useMemo(
    () => selectedProject?.blockchains ?? [],
    [selectedProject],
  );

  const projectChain = useMemo(() => {
    if (chainPaths.length === 0) {
      return chain;
    }

    return filterChainByPaths({ chain, paths: chainPaths });
  }, [chain, chainPaths]);

  const selectedToken = useMemo(() => {
    return selectedProject?.userEndpointToken;
  }, [selectedProject]);

  return {
    handleOpenAddToProjectsDialog,
    isAddToMetamaskButtonVisible,
    projectChain,
    selectedToken,
  };
};
